<script>
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";

	export let disabled = null;
	export let bindList = [];
	export let listModel = null;
	export let modelName = null;
	export let questionText = null;
	export let subHeading = null;
	export let subHtml = null;
	export let rowDefinition = null;
	export let idPrefix = "";

	if (!listModel) {
		console.error("ListForm requires a defined listModel prop passed");
		throw new Error("ListForm requires a defined listModel prop passed");
	}

	$: if (!bindList || !Array.isArray(bindList)) bindList = [];

	//$: if (bindList.length === 0) bindList = [new listModel()];

	const now = () => {
		let n = new Date();
		let d = (n.getDate() < 10 ? "0" : "") + n.getDate();
		let m = (n.getMonth() + 1 < 10 ? "0" : "") + (n.getMonth() + 1);
		return `${d}/${m}/${n.getFullYear()}`;
	};

	const addEntry = () => {
		bindList = [...bindList, new listModel()];
	};

	const removeEntry = (item, index) => {
		item.DateDeleted = now();
		item.DeletedBy = "Registration";
		bindList = [...bindList];

		bindList.splice(index, 1);
		bindList = [...bindList];
	};

	$: displayList = bindList ? bindList.filter((b) => !b.DateDeleted) : [];
</script>

<div class="form-group form-row">
	<div class="col-md-12">
		{#if questionText}<h2>{questionText}</h2>{/if}
		{#if subHeading}<h4>{subHeading}</h4>{/if}
		{#if subHtml}<p>{@html subHtml}</p>{/if}
		{#if !disabled}
			<FormRow>
				<FormColumn>
					<button
						class="btn btn-primary btn-sm"
						title={`Add ${modelName}`}
						on:click|preventDefault={() => addEntry()}>Add {modelName}</button
					>
				</FormColumn>
			</FormRow>
		{/if}

		<div class="listWrapper">
			{#if displayList && displayList.length > 0}
				<div class="row list-header-row no-gutters">
					{#each Object.values(rowDefinition) as row}
						<FormColumn cols={row.rowWidth}>
							{row.rowTitle}
						</FormColumn>
					{/each}
				</div>
				{#each displayList as item, i}
					<div class="row list-row no-gutters">
						{#each Object.values(rowDefinition) as row}
							<FormColumn cols={row.rowWidth}>
								{#if row.bindTarget === "formattedSelected"}
									<svelte:component
										this={row.rowComponent}
										id={`${idPrefix}${row.rowDataName}${i}`}
										{...row.rowComponentProps}
										bind:formattedSelected={item[row.rowDataName]}
										{disabled}
									/>
								{:else}
									<svelte:component
										this={row.rowComponent}
										id={`${idPrefix}${row.rowDataName}${i}`}
										{...row.rowComponentProps}
										bind:value={item[row.rowDataName]}
										{disabled}
									/>
								{/if}
							</FormColumn>
						{/each}
						{#if displayList.length > 0 && !disabled}
							<FormColumn cols="1" class="last">
								<button
									type="button"
									class="btn btn-outline-secondary btn-sm"
									on:click={() => removeEntry(item, i)}>Remove</button
								>
							</FormColumn>
						{/if}
					</div>
				{/each}
			{/if}
		</div>
	</div>
</div>

<style>
	.list-header-row {
		margin-bottom: 6px;
		font-size: 0.9em;
		font-weight: 700;
	}

	.list-row {
		margin-bottom: 4px;
	}

	@media only screen and (max-width: 755px) {
		.listWrapper {
			display: flex;
		}

		.listWrapper.list-header-row > div {
			margin: 0;
			text-overflow: ellipsis;
			overflow: hidden;
			padding-right: 10px;
			white-space: nowrap;
		}
	}
</style>
